import React from "react";
import { Box, Avatar, Typography } from "@mui/material";
import { useApp } from "../../Context/AppContext";

const UserProfileComponent = () => {
  const { user } = useApp();

  return (
    <Box
      sx={{
        fontSize: { xs: "12px", sm: "12px", md: "12px" },
        display: { xs: "block", sm: "block", md: "flex" },
        flexDirection: "row",
        alignItems: "center",
        gap: 2,
        textAlign: { xs: "center", sm: "center", md: "left" },
      }}
    >
      {/* Left Column: Profile Image */}
      <Box position="relative">
        <Avatar
          alt="User Profile"
          src={user?.profilePic ? user?.profilePic : ""} // Dynamic profile image
          sx={{
            width: 50,
            height: 50,
            border: "3px solid #ddd",
            margin: { xs: "0 auto", sm: "0 auto", md: "0 auto" },
          }}
        />
      </Box>

      {/* Right Column: User Info */}
      <Box className="profileInfoColumn">
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: { xs: "16px", sm: "16px", md: "16px" } }}
        >
          {user?.fullName}
        </Typography>
        <Typography className="username" variant="body2" color="text.secondary">
          {user?.username}
        </Typography>
        {/* <Typography className="companyName" variant="body1" mt={1}>
          {user?.company}
        </Typography> */}
      </Box>
    </Box>
  );
};

export default UserProfileComponent;
